import {
  GET_TERMS_LOADING,
  GET_TERMS_SUCCESS,
  GET_TERMS_FAILED,
  STATUS_DEFAULT,
  STATUS_GETTING,
  STATUS_GET_SUCCESS,
  STATUS_GET_FAILED,
  RESET_TERMS,
} from 'Redux/actions/types';

const initialState = {
  status: STATUS_DEFAULT,
  statusCode: null,
  errorCode: null,
  data: null,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_TERMS_LOADING:
      return {
        status: STATUS_GETTING,
        errorCode: null,
      };

    case GET_TERMS_SUCCESS:
      return {
        data: payload,
        status: STATUS_GET_SUCCESS,
        errorCode: null,
      };

    case GET_TERMS_FAILED:
      return {
        status: STATUS_GET_FAILED,
        statusCode: payload.statusCode,
        errorCode: payload.errorCode,
      };

    case RESET_TERMS:
      return initialState;

    default:
      return state;
  }
};
